
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.2), rgba(30, 64, 175, 0.3)), url('https://public.readdy.ai/ai/img_res/ada41e35218ac2cd900ec048f018549e.jpg')`
      }}
    >
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Learn English the 
            <span className="text-yellow-300"> Fun & Easy</span> Way
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 leading-relaxed drop-shadow-md">
            Master English with interactive exercises, personalized lessons, and real-world practice. 
            Track your progress and get personal guidance when you need it most.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link
              to="/learn"
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-300 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              Start Learning Now
            </Link>
            <Link
              to="/lessons"
              className="bg-white text-blue-600 border-2 border-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-video-chat-line mr-2"></i>
              Book Private Lesson
            </Link>
          </div>

          {/* Features Preview */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-gamepad-line text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Interactive Exercises</h3>
              <p className="text-gray-600">Practice writing, speaking, listening, and vocabulary with fun, engaging activities.</p>
            </div>
            
            <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-green-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Track Progress</h3>
              <p className="text-gray-600">See your improvement with detailed progress tracking and achievement badges.</p>
            </div>
            
            <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-heart-line text-purple-600 text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Personal Guidance</h3>
              <p className="text-gray-600">Get one-on-one video lessons with me for personalized feedback and support.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
